import React, { useState, useEffect } from "react";
import { Menu, X, Zap } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/constants";
import { Button } from "@/components/ui/button";

const links = [
  { href: "#servicios", label: "Servicios" },
  { href: "#cotizador", label: "Cotizador" },
  { href: "#proceso", label: "Proceso" },
  { href: "#equipo", label: "Equipo" },
  { href: "#contacto", label: "Contacto" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[#0a0a0a]/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group"
        >
          <span className="relative w-9 h-9 grid place-items-center bg-[#ff6b00] text-black">
            <Zap className="w-5 h-5" strokeWidth={2.5} />
            <span className="absolute inset-0 border border-[#ff6b00] translate-x-1 translate-y-1 -z-10" />
          </span>
          <div className="leading-tight">
            <div className="font-display text-sm font-bold tracking-tight">
              TRANSFORMADORES BUCARAMANGA
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#a0aabf]">
              Venta, Mantenimiento y Reparación
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-[#a0aabf] hover:text-white transition-colors uppercase tracking-wider font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="navbar-cta-whatsapp"
          >
            <Button className="bg-[#ff6b00] hover:bg-[#e65a00] text-black font-bold uppercase tracking-wider text-xs rounded-none px-6 h-11">
              Solicitar Cotización
            </Button>
          </a>
        </div>

        <button
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 grid place-items-center border border-white/10"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/5 bg-[#0a0a0a]/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className="text-[#a0aabf] hover:text-white text-sm uppercase tracking-wider"
              >
                {l.label}
              </a>
            ))}
            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="noreferrer"
              className="mt-2"
              data-testid="mobile-nav-cta"
            >
              <Button className="w-full bg-[#ff6b00] hover:bg-[#e65a00] text-black font-bold uppercase tracking-wider text-xs rounded-none h-12">
                Cotizar por WhatsApp
              </Button>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
